module.exports = __webpack_public_path__ + "static/logo_lgv-drivers-choice-e407c7805e097684cfde3b3701fcd6a9.png";